/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from 'src/app/service/auth.service';
import { FeatureFlagsService } from 'src/app/shared/services/customer-api/feature-flags.service';
import { QueryApiService } from 'src/app/shared/services/customer-api/query-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { from, of } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { QueryEditorComponent } from '../query-editor/query-editor.component';
import { QueryImportComponent } from '../query-import/query-import.component';
import { RoutingService } from 'src/app/service/routing.service';
import { QueryNameComponent } from '../query-name/query-name.component';
import * as FileSaver from 'file-saver';
import { resolveSortOrder } from 'src/app/shared/constants/sort-param-map';
import { SentimentService } from 'src/app/shared/services/data-api/sentiment.service';

const QUERY_FOLIO_SORT_MAP: Record<string, string> = {
  senti: '-sentiment.sentiment',
  '-senti': 'sentiment.sentiment',
  abc: 'query.name',
  '-abc': '-query.name',
  trend: '-sentiment.sentiment_delta',
  '-trend': 'sentiment.sentiment_delta',
  count: '-sentiment.count',
  '-count': 'sentiment.count',
  ratio: '-sentiment.volume_ratio',
  '-ratio': 'sentiment.volume_ratio',
};

const QUERY_FOLIO_DEFAULT_SORT_MAP: Record<string, string> = {
  abc: 'query.name',
  '-abc': '-query.name',
};
import { ColorPipe } from 'src/app/pipe/color.pipe';
import { ColorRatioPipe } from 'src/app/pipe/colorRatio.pipe';
import { autocollection } from './preset-collection';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-query-folio',
  templateUrl: './query-folio.component.html',
  styleUrls: ['./query-folio.component.scss'],
})
export class QueryFolioComponent {
  items: any;
  itemsCountMin: any;
  itemsCountMax: any;
  itemsTrendMax: any;
  itemsTrendMin: any;
  itemsRatioMax: any;
  itemsRatioMin: any;

  itemsLoaded: any;

  selectedQueries: any;

  currentQuery: any;

  isQueryAdded: boolean;

  /**
   * collection content in the news-table's format
   */
  itemsFiltered: any;

  query: any;
  myOrder: string;
  params: any;
  previousValue: any;

  constructor(
    public auth: AuthService,
    public featureFlagsService: FeatureFlagsService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public routing: RoutingService,
    private sentimentService: SentimentService,
    public queryApi: QueryApiService,
    private destroyRef: DestroyRef,
  ) {
    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.params = params;
        this.isQueryAdded = false;
        if (routing.reFresh(params, this.previousValue, ['update'])) {
          this.isQueryAdded = true;
        }
        if (
          routing.reFresh(params, this.previousValue, [
            'id',
            'groupId',
            'update',
            'time',
            'lang',
            'feed',
            'categories',
            'continents',
            'countries',
            'factuality',
            'temporality',
            'ranks' /*, 'sort', 'defaultsort'*/,
            'panels',
          ])
        ) {
          let itemsCopy = null;
          let itemsCopyIds = [];
          if (this.items) {
            itemsCopy = JSON.parse(JSON.stringify(this.items));
            itemsCopyIds = this.items.map((item) => item.query.uid);
          }
          this.items = null;
          this.itemsLoaded = false;
          this.selectedQueries = [];
          const query = [];
          if (this.queryApi.iquery && this.params.id !== 'default') {
            if (!this.queryApi.iquery || this.queryApi.iquery.length === 0) {
              this.items = [];
            }
            this.items = [];
            const itemsLength = this.queryApi.iquery.length;
            let itemsCount = 0;
            const data = [];
            this.queryApi.iquery.forEach((item) => {
              const params = JSON.parse(JSON.stringify(this.params));
              params['iquery'] = Object.assign({}, item.query, {
                uid: item.uid,
              });
              // const request = this.yukkApi.isentiment(params, false);
              query.push(params);
              this.items.push({
                query: item,
              });
            });
            from(query)
              .pipe(
                concatMap((req, index) => {
                  if (
                    this.isQueryAdded &&
                    itemsCopy &&
                    this.queryApi.iquery &&
                    this.queryApi.iquery[index] &&
                    itemsCopyIds.includes(this.queryApi.iquery[index].uid) &&
                    !(
                      params.queryid &&
                      params.queryid === this.queryApi.iquery[index].uid
                    )
                  ) {
                    return of(
                      itemsCopy.filter((item) => {
                        return (
                          item.query.uid === this.queryApi.iquery[index].uid
                        );
                      })[0],
                    );
                  } else {
                    // A failed item must still emit — the completion condition
                    // counts emissions, so an error here froze the table.
                    return this.sentimentService
                      .getSentiment(req, false)
                      .pipe(catchError(() => of(undefined)));
                  }
                }),
              )
              .subscribe((queryItem2) => {
                const queryItem = queryItem2
                  ? JSON.parse(JSON.stringify(queryItem2))
                  : undefined;
                this.items[itemsCount].sentiment = queryItem?.sentiment;
                data.push(queryItem);
                itemsCount++;
                if (itemsCount === itemsLength) {
                  this.items = data.map((itom: any, index: number) => {
                    if (itom) {
                      itom['query'] = this.queryApi.iquery[index];
                      return itom;
                    } else {
                      return {
                        query: this.queryApi.iquery[index],
                      };
                    }
                  });
                  this.itemsFiltered = this.items.map((item) => {
                    return {
                      id: item.query ? item.query.uid : undefined,
                      type: 'query',
                      name: item.query ? item.query.name : undefined,
                      sentiment: item.sentiment
                        ? item.sentiment.sentiment
                        : undefined,
                      trend: item.sentiment
                        ? item.sentiment.sentiment_delta
                        : undefined,
                      count: item.sentiment ? item.sentiment.count : undefined,
                      ratio: item.sentiment
                        ? item.sentiment.volume_ratio
                        : undefined,
                    };
                  });
                  const definedItems = this.items.filter((item) => {
                    return item.sentiment;
                  });
                  this.itemsCountMax = Math.max(
                    ...definedItems.map((item) => {
                      return item.sentiment.count;
                    }),
                    1,
                  );
                  this.itemsCountMin = Math.min(
                    ...definedItems.map((item) => {
                      return item.sentiment.count;
                    }),
                    0,
                  );
                  this.itemsTrendMax = Math.max(
                    ...definedItems.map((item) => {
                      return item.sentiment.sentiment_delta;
                    }),
                  );
                  this.itemsTrendMin = Math.min(
                    ...definedItems.map((item) => {
                      return item.sentiment.sentiment_delta;
                    }),
                  );
                  this.itemsRatioMax = Math.max(
                    ...definedItems.map((item) => {
                      return item.sentiment.volume_ratio;
                    }),
                  );
                  this.itemsRatioMin = Math.min(
                    ...definedItems.map((item) => {
                      return item.sentiment.volume_ratio;
                    }),
                  );
                  this.itemsLoaded = true;
                }
              });
          } else if (this.queryApi.iquery && this.params.id === 'default') {
            this.items = this.queryApi.iquery.map((element) => {
              return {
                query: element,
                entity: {},
                sentiment: {},
              };
            });
          } else {
            this.items = [];
            // this.iQuery()
          }
        }

        this.previousValue = params;
        if (params.defaultsort) {
          this.myOrder = resolveSortOrder(
            params.defaultsort,
            QUERY_FOLIO_DEFAULT_SORT_MAP,
            '-sentiment.count',
          );
        } else {
          this.myOrder = resolveSortOrder(
            params.sort,
            QUERY_FOLIO_SORT_MAP,
            '-sentiment.count',
          );
        }
      });
  }

  listContainingCollections(item) {
    const collections = this.queryApi.querys
      .filter((collection) => {
        return item.query.groups.includes(collection.uid);
      })
      .map((element) => {
        return element.name;
      });
    if (collections && collections.length !== 0) {
      return collections;
    } else {
      return [];
    }
  }

  listContainingQueries(item) {
    return item.query.referenced_by?.map((e) => e.name);
  }

  selectQuery(item) {
    let check = false;
    const filteredQueries = this.selectedQueries.filter((query) => {
      if (query.uid === item.uid) {
        check = true;
      }
      return query.uid !== item.uid;
    });
    if (check) {
      this.selectedQueries = filteredQueries;
    } else {
      this.selectedQueries.push(item);
    }
  }

  private neutralBackground(): string {
    return this.routing.theme === 'light'
      ? 'rgb(216,216,216)'
      : 'rgb(120,120,120)';
  }

  getBackground(item) {
    if (this.myOrder === 'query.name' || this.myOrder === '-query.name') {
      const filterPipe = new ColorRatioPipe(this.routing);
      const value = item.sentiment ? item.sentiment.volume_ratio : undefined;
      if (!this.itemsLoaded) {
        return this.neutralBackground();
      } else {
        return filterPipe.transform(
          value,
          this.itemsRatioMin,
          this.itemsRatioMax,
        );
      }
    }
    if (
      this.myOrder === '-sentiment.count' ||
      this.myOrder === 'sentiment.count'
    ) {
      const filterPipe = new ColorRatioPipe(this.routing);
      const value = item.sentiment ? item.sentiment.volume_ratio : undefined;
      if (!this.itemsLoaded) {
        return this.neutralBackground();
      } else {
        return filterPipe.transform(
          value,
          this.itemsRatioMin,
          this.itemsRatioMax,
        );
      }
    }
    if (
      this.myOrder === '-sentiment.volume_ratio' ||
      this.myOrder === 'sentiment.volume_ratio'
    ) {
      const filterPipe = new ColorRatioPipe(this.routing);
      let value = item.sentiment
        ? item.sentiment.volume_ratio
          ? item.sentiment.volume_ratio
          : undefined
        : undefined;
      if (
        item.sentiment &&
        (item.sentiment.volume_ratio === null ||
          item.sentiment.volume_ratio === 0) &&
        item.sentiment.count &&
        item.sentiment.count > 0
      ) {
        value = this.itemsRatioMin;
      }
      if (!this.itemsLoaded) {
        return this.neutralBackground();
      } else {
        return filterPipe.transform(
          value,
          this.itemsRatioMin,
          this.itemsRatioMax,
        );
      }
    }
    if (
      this.myOrder === '-sentiment.sentiment' ||
      this.myOrder === 'sentiment.sentiment'
    ) {
      const filterPipe = new ColorPipe(this.routing);
      const value = item.sentiment ? item.sentiment.sentiment : undefined;
      if (!this.itemsLoaded || value === undefined) {
        return this.neutralBackground();
      } else {
        return filterPipe.transform(value);
      }
    }
    if (
      this.myOrder === '-sentiment.sentiment_delta' ||
      this.myOrder === 'sentiment.sentiment_delta'
    ) {
      const filterPipe = new ColorPipe(this.routing);
      const value = item.sentiment ? item.sentiment.sentiment : undefined;
      if (!this.itemsLoaded || value === undefined) {
        return this.neutralBackground();
      } else {
        return filterPipe.transform(value);
      }
    }
  }

  iNewone() {
    this.dialog.open(QueryEditorComponent, {});
  }

  iEdit(item) {
    this.dialog.open(QueryEditorComponent, {
      data: item.query,
    });
  }

  iDelete() {
    if (this.selectedQueries.length !== 0) {
      if (window.confirm('Do you want to delete selected queries?')) {
        const queriesIds = this.selectedQueries.map((query) => query.uid);
        this.queryApi.delQueries(queriesIds).subscribe(() => {
          this.router.navigate([], {
            queryParams: {
              update: Math.random(),
              queryid: null,
              newsfeedFromQuery: null,
            },
            queryParamsHandling: 'merge',
          });
        });
      }
    }
  }

  iManage() {
    this.router.navigate([], {
      queryParams: {
        id: 'default',
        groupId: 'default',
        defaultsort: 'abc',
        queryid: null,
        newsfeedFromQuery: null,
      },
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
  }

  iChart(item) {
    const queryGroupId =
      this.params.groupId == 'default'
        ? item.query.groups[0]
        : this.params.groupId;
    this.router.navigate(['../chart'], {
      queryParams: {
        id: item.query.uid,
        newsfeedFromQuery: null,
        queryid: null,
        groupId: queryGroupId,
      },
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
  }

  /**
   * add tag to the url on item click
   */
  addTag(item) {
    if (this.params.newsfeedFromQuery === item.query.uid) {
      this.queryApi.queryForNewsfeed = null;
    } else {
      this.queryApi.queryForNewsfeed = item;
    }
    this.router.navigate([], {
      queryParams: {
        newsfeedFromQuery:
          this.params.newsfeedFromQuery === item.query.uid
            ? null
            : item.query.uid,
        newstype: null,
        queryid: null,
      },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  }

  onMouseEnterName(id) {
    this.currentQuery = id;
  }

  onMouseLeaveName() {
    this.currentQuery = null;
  }

  iImport(event, type) {
    if (event === null && type === 'query') {
      if (
        this.items &&
        this.items.length >=
          this.featureFlagsService.featureFlags.queriesPerCollectionsLimit
      ) {
        this.snackBar.open(
          'Number of queries per collection is limited to ' +
            this.featureFlagsService.featureFlags.queriesPerCollectionsLimit +
            '.',
          'OK',
          { duration: 5000 },
        );
      } else {
        const currentCollection = this.queryApi.querys
          ? this.queryApi.querys.filter((item) => {
              return item.uid === this.params.id;
            })[0]
          : {};
        this.dialog.open(QueryImportComponent, {
          data: {
            collection: currentCollection,
            queries: this.items.map((element) => {
              return element.query;
            }),
          },
        });
      }
    } else if (event !== null && type === 'collection') {
      if (
        this.queryApi.querys &&
        event.target.files &&
        this.queryApi.querys.length + event.target.files.length >
          this.featureFlagsService.featureFlags.collectionsLimit
      ) {
        this.snackBar.open(
          'Number of collections is limited to ' +
            this.featureFlagsService.featureFlags.collectionsLimit +
            '.',
          'OK',
          { duration: 5000 },
        );
      } else {
        if (event.target.files && event.target.files[0]) {
          for (let i = 0; i < event.target.files.length; i++) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
              const result = JSON.parse(e.target.result);
              if (
                result.content &&
                result.content.length >
                  this.featureFlagsService.featureFlags
                    .queriesPerCollectionsLimit
              ) {
                this.snackBar.open(
                  'Number of queries per collection is limited to ' +
                    this.featureFlagsService.featureFlags
                      .queriesPerCollectionsLimit +
                    '.',
                  'OK',
                  { duration: 5000 },
                );
              } else {
                this.queryApi
                  .addGroupQuery(result.name)
                  .subscribe((result2) => {
                    const queriesArray = [];
                    result.content.forEach((query) => {
                      queriesArray.push(
                        Object.assign({}, query, {
                          groups: [result2.id],
                        }),
                      );
                    });
                    this.queryApi.addQueries(queriesArray).subscribe(() => {
                      this.router.navigate([], {
                        queryParams: {
                          id: result2.id,
                          groupId: result2.id,
                          update: Math.random(),
                          queryid: null,
                          newsfeedFromQuery: null,
                        },
                        queryParamsHandling: 'merge',
                      });
                    });
                  });
              }
            };
            reader.readAsText(event.target.files[i]);
          }
        }
      }
    } else if (event !== null && type === 'query') {
      if (event.target.files && event.target.files[0]) {
        for (let i = 0; i < event.target.files.length; i++) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            const result = JSON.parse(e.target.result);
            const data = {
              groups: ['default'],
              name: result.name,
              description: result.description,
              query: result.query,
            };
            this.queryApi.addQuery(data).subscribe((result2) => {
              this.queryApi.getGroupsQuery().subscribe((groups) => {
                groups.map((group) => {
                  if (group.uid === result2.uid) {
                    this.queryApi.iquery = group.content;
                    this.queryApi.query = {
                      uid: group.uid,
                      name: group.name,
                      query: {
                        operator: 'or',
                        filters: [],
                        groups: group.content.map((query) => query.query),
                      },
                    };
                  }
                });
              });
              this.router.navigate([], {
                queryParams: {
                  update: Math.random(),
                  queryid: null,
                  newsfeedFromQuery: null,
                },
                queryParamsHandling: 'merge',
              });
            });
          };
          reader.readAsText(event.target.files[i]);
        }
      }
    }
  }

  iQuery() {
    if (
      !(this.params.id === 'default') &&
      this.items &&
      this.items.length >=
        this.featureFlagsService.featureFlags.queriesPerCollectionsLimit
    ) {
      this.snackBar.open(
        'Number of queries per collection is limited to ' +
          this.featureFlagsService.featureFlags.queriesPerCollectionsLimit +
          '.',
        'OK',
        { duration: 5000 },
      );
    } else {
      this.dialog.open(QueryEditorComponent, {
        // data: {}
      });
    }
  }

  iModify() {
    this.dialog.open(QueryNameComponent, {
      data: this.queryApi.query ? this.queryApi.query : {},
    });
  }

  iCreate() {
    if (
      this.queryApi.querys &&
      this.queryApi.querys.length >=
        this.featureFlagsService.featureFlags.collectionsLimit
    ) {
      this.snackBar.open(
        'Number of collections is limited to ' +
          this.featureFlagsService.featureFlags.collectionsLimit +
          '.',
        'OK',
        { duration: 5000 },
      );
    } else {
      this.dialog.open(QueryNameComponent, {
        // data: {}
      });
    }
  }

  // inTab(uid) {
  //   this.router.navigate([], {
  //     queryParams: {
  //       id: uid,
  //       groupId: uid
  //     },
  //     queryParamsHandling: 'merge',
  //     relativeTo: this.route
  //   });
  // }

  iExport(type) {
    /*if (type === 'events') {
      this.yukkApi.exportEvent(this.params, 'query').subscribe(result => {
        FileSaver.saveAs(result, 'event_export.xlsx');
      });
    } else */
    if (type === 'collection') {
      const collectionPure = this.queryApi.querys
        .filter((collection) => {
          return collection.uid === this.params.groupId;
        })
        .map((element) => {
          return {
            name: element.name,
            content: element.content.map((query) => {
              return {
                name: query.name,
                query: query.query,
              };
            }),
          };
        })[0];
      const collectionString = JSON.stringify(collectionPure);
      const blob = new Blob([collectionString], { type: 'application/json' });
      FileSaver.saveAs(blob, 'collection_' + collectionPure.name + '.json');
    } else if (type === 'queries') {
      this.selectedQueries.forEach((query) => {
        const queryPure = {
          name: query.name,
          query: query.query,
        };
        const queryString = JSON.stringify(queryPure);
        const blob = new Blob([queryString], { type: 'application/json' });
        FileSaver.saveAs(blob, 'query_' + queryPure.name + '.json');
      });
    } else if (type === 'stats') {
      if (this.items && this.items.length > 0) {
        const date = new Date();
        const displayDate =
          date.getFullYear() +
          '-' +
          date.getMonth() +
          '-' +
          date.getDate() +
          ' ' +
          date.getHours() +
          '-' +
          date.getMinutes() +
          '-' +
          date.getSeconds();
        const doubleArrayData = [['Name', 'Vol', 'ΔVol', 'Sent', 'ΔSent']];
        this.items.forEach((query) => {
          doubleArrayData.push([
            query.query && query.query.name ? query.query.name : '',
            query.sentiment && query.sentiment.count
              ? query.sentiment.count
              : '',
            query.sentiment && query.sentiment.volume_ratio
              ? query.sentiment.volume_ratio
              : '',
            query.sentiment && query.sentiment.sentiment
              ? query.sentiment.sentiment
              : '',
            query.sentiment && query.sentiment.sentiment_delta
              ? query.sentiment.sentiment_delta
              : '',
          ]);
        });
        /* generate worksheet */
        const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(doubleArrayData);
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        /* save to file */
        XLSX.writeFile(
          wb,
          'Collection statistics from ' + displayDate + '.xlsx',
        );
      }
    }
  }

  /**
   * apply chosen sorting option
   */
  goSort(value) {
    if (this.params.sort === value) {
      this.router.navigate([], {
        queryParams: { sort: '-' + value },
        queryParamsHandling: 'merge',
        replaceUrl: false,
      });
    } else {
      this.router.navigate([], {
        queryParams: { sort: value },
        queryParamsHandling: 'merge',
        replaceUrl: false,
      });
    }
  }

  /**
   * apply chosen sorting option for default collection (queries management page)
   */
  goDefaultSort(value) {
    if (this.params.defaultsort === value) {
      this.router.navigate([], {
        queryParams: { defaultsort: '-' + value },
        queryParamsHandling: 'merge',
        replaceUrl: false,
      });
    } else {
      this.router.navigate([], {
        queryParams: { defaultsort: value },
        queryParamsHandling: 'merge',
        replaceUrl: false,
      });
    }
  }

  loadSampleCollections() {
    for (let i = 0; i < autocollection.length; i++) {
      const result = autocollection[i];
      this.queryApi.addGroupQuery(result.name).subscribe((result2) => {
        const queriesArray = [];
        result.content.forEach((query) => {
          queriesArray.push(
            Object.assign({}, query, {
              groups: [result2.id],
            }),
          );
        });
        this.queryApi.addQueries(queriesArray).subscribe(() => {
          this.router.navigate([], {
            queryParams: {
              id: result2.id,
              groupId: result2.id,
              update: Math.random(),
              queryid: null,
              newsfeedFromQuery: null,
            },
            queryParamsHandling: 'merge',
          });
        });
      });
    }
  }
}
